import { CreateWithBudButton } from "../../assistant/components/CreateWithBudButton";
import * as React from "react";
import { Grid, Typography } from "@mui/material";

import { FruitifyContainer } from "../../../shared-components/Containers";
import { useNavigate, useSearchParams } from "react-router-dom";
import { withPageTracking } from "../../../services/postHog";
import { ActionCard } from "../../../shared-components/ActionCards";

const QuizCreate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const classId = searchParams.get("classId");

  const handleAddNewClicked = () => {
    if (classId) {
      navigate(`new?classId=${classId}`);
    } else {
      navigate(`new`);
    }
  };

  const handleExistingClicked = () => {
    if (classId) {
      navigate(`from-existing?classId=${classId}`);
    } else {
      navigate(`from-existing`);
    }
  };
  return (
    <FruitifyContainer>
      <Typography variant="h3" fontWeight="bold">
        Create quiz
      </Typography>
      <Grid container spacing={2} sx={{ width: "100%", mt: 2 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <ActionCard
            title="Create a new quiz"
            subtitle="Create a quiz from scratch using new or existing questions"
            iconName="Edit"
            onAdd={handleAddNewClicked}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <CreateWithBudButton kind="quiz" classId={classId} asCard />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <ActionCard
            title="Choose existing quizzes"
            subtitle="Browse and select from previously created quizzes."
            iconName="FolderOpen"
            onAdd={handleExistingClicked}
          />
        </Grid>
      </Grid>
    </FruitifyContainer>
  );
};

export default withPageTracking(QuizCreate, {
  feature: "quiz-create",
});
